import { CONSTRUCTION_DEALS } from '../sharedConfig';

// budgetAllocation values are relative weights, NOT percentages.
// The formula (weight / sumOfSelectedWeights) × sourceBudget distributes 100%
// of the source line item's budget across whichever items are enabled.
export default {
  key: 'construction',
  label: 'Construction Display',
  strategySets: {
    default: {
      label: 'Standard (6 items)',
      lineItems: [
        { name: 'CPM_BT_B2B_Construction_WithSegments_DIS_Prospecting', segment: 'CONSTRUCTION_INDUSTRY_B2B', budgetAllocation: 40 },
        { name: 'CPM_CT_B2B_Construction_x_DIS_Prospecting', segment: null, budgetAllocation: 30, contextualTarget: { name: 'Construction Industry B2B Content Categories', listId: '1639091398' } },
        { name: 'CPM_CT_TopKeywords_Construction_x_DIS_Prospecting', segment: null, budgetAllocation: 10, contextualTarget: { name: 'SRS B2B Contractor Top KW List', listId: '1163736392' } },
        { name: 'CPM_CT_ExpandedKeywords_Construction_x_DIS_Prospecting', segment: null, budgetAllocation: 7, contextualTarget: { name: 'SRS Prospecting KW List Expanded', listId: '1163736391' } },
        { name: 'CPM_CT_Competitors_Construction_x_DIS_Prospecting', segment: null, budgetAllocation: 10, contextualTarget: { name: 'SRS Competitors KW List', listId: '1163736390' } },
        { name: 'CPM_CT_CuratedSiteList-VariousCompetitors_Construction_x_DIS_Prospecting', segment: 'CONSTRUCTION_INDUSTRY_B2B', budgetAllocation: 3 },
      ],
    },
  },
  deals: CONSTRUCTION_DEALS,
};
